const translate = {
    common: {
        audit: "Аудит",
        login: "Логин",
        password: "Пароль",
        maskedPassword: "**********",
        date: "Дата",
        today: "Сегодня",
        yesterday: "Вчера",
        currentWeek: "Текущая неделя",
        currentMonth: "Текущий месяц",
        currentYear: "Текущий год",
        period: "Период",
        tier: "Уровень",
        save: "Сохранить",
        operators: "Операторы",
        search: "Поиск",
        online: "Онлайн",
        pause: "Пауза",
        offline: "Офлайн",
        chats: "Чаты",
        chat: "Чат",
        channels: "Каналы",
        type: "Тип",
        token: "Токен",
        enabled: "Включен",
        name: "Название",
        settings: "Настройки",
        permissions: "Разрешения",
        contact: "Контакт",
        channel: "Канал",
        accounts: "Аккаунты",
        contactCommunications: "Средства связи",
        cancel: "Отменить",
        delete: "Удалить",
        restore: "Восстановить",
        detach: "Отделить",
        contacts: "Контакты",
        messengers: "Мессенджеры",
        created: "Создан",
        status: "Статус",
        mailing: "Рассылки",
        start: "Начать",
        message: "Сообщение",
        analytics: "Аналитика",
        synonyms: "Синонимы",
        export: "Экспорт",
        import: "Импорт",
        publish: "Опубликовать",
        changeVersion: "Сменить версию",
        undo: "Отменить изменения",
        answer: "Ответ",
        active: "Активные",
        inactive: "Неактивные",
        pending: "В ожидании",
        apply: "Применить",
        setting: "Настройка",
        edited: "изменено",
        editAsJson: "Редактировать как JSON",
        editAsTable: "Редактировать как таблицу",
        image: "Изображение",
        file: "Файл",
        send: "Отправить",
        close: "Закрыть",
        reject: "Отклонить",
        confirm: "Подтвердить",
        setOn: "Установлен",
        logout: "Выйти",
        wrongPasswordOrLoginOrLicenseMessage: "Ошибка авторизации. Проверьте логин и пароль.",
        id: "Ид",
        operator: "Оператор",
        channelType: "Тип канала",
        channelName: "Название канала",
        chatTag: "Тег",
        phrase: "Фраза",
        data: "Данные",
        fileSendLikeImageError: "Данный тип изборажения можно отправить только как файл",
        changesNotBeApplied: "Внесенные изменения не будут применены к измененным настройкам",
        supervisor: "Супервизор",
        admin: "Админ",
        bot: "Бот",
        offlineStatusConfirmation: "При переходе в оффлайн все чаты будут сняты и распределены в очередь. Продолжить?",
        chatType: "Тип чата",
        operatorType: "Тип оператора",
        messengerExternalId: "Внешний ид средства связи",
        ascending: "По возрастанию",
        descending: "По убыванию",
        ai: "ИИ",
        attachment: "Вложение",
        stop: "Остановить",
        location: "Местоположение",
        audio: "Аудио",
        video: "Видео",
        device: "Устройство",
        browser: "Браузер",
    },
    analytics: {
        statistics: "Статистика",
        monitoring: "Мониторинг",
        reports: "Отчеты",
        exportReport: "Экспорт",
        comeFrom: "Предыдущий шаг",
        dialog: "Диалог",
        wentTo: "Следующий шаг",
        getSettingForChartsMessage: "Не удается загрузить настройки для диаграмм.",
        reportOutOfRangeException: "Невозможно сформировать отчет из-за ограничений формата файла.",
        reportException: "Произошла ошибка при выгрузке отчета."
    },
    channels: {
        operatorsForChannel: "Операторы для канала",
        operator: "Оператор",
        feedback: "Фидбэк",
        vip: "ВИП",
        spam: "Спам",
        comments: "Комментарии",
        emptyNameTooltipErrorMessage: "Имя не может быть пустым",
        emptyTokenTooltipErrorMessage: "Токен не может быть пустым",
        channelCreatingErrorMessage: "Пожалуйста, сохраните или удалите новый канал",
        createChannel: "Создать канал",
        sureDeleteChannel: "Вы действительно хотите удалить канал?",
        saveChannelSuccessMessage: "Сохранено успешно",
        saveNewChannelSuccessMessage: "Канал создан успешно",
        saveChannelErrorMessage: "Ошибка при сохранении канала",
        saveNewChannelErrorMessage: "Не сохраняется новый канал",
        channelAlreadyExists: "Канал с таким токеном уже существует",
        uniformWidgetStartSignalRError: "Произошла ошибка при подключении к коннектору {{url}}",
        deleteChannelSuccessMessage: "Удалено успешно",
        deleteNewChannelSuccessMessage: "Канал не сохранился",
        deleteChannelErrorMessage: "Ошибка при удалении канала",
        deleteNewChannelErrorMessage: "Канал с идентификатором {0} не может быть удален, так как в нем открыты чаты:",
        copyScriptHeader: "Скрипт скопирован",
        copyScriptBody: "Скрипт скопирован в буфер обмена. Используйте Ctrl+V, чтобы вставить его на свой сайт.",
        telegram: "Телеграм",
        viber: "Вайбер",
        viberAlfa: "Вайбер альфа",
        vk: "Вк",
        widget: "Виджет",
        facebook: "Фейсбук",
        weChat: "ВиЧат",
        instagram: "Инстаграм",
        uniformWidget: "Виджет Униформы",
        ednaWhatsApp: "Вотсап (Edna)",
        whatsApp: "Вотсап",
        voiceChannel: "Голосовой канал",
        telegramPrivate: "Телеграм (Личный)",
        restartChannelSuccessMesage: "Канал успешно перезапущен",
        restartChannelQuestion: "Вы уверены, что хотите перезапустить канал?",
        restartOnlyEnabledChannel: "Канал должен быть включен",
        askYouWannaDeleteChannel: "{0} пользователь(ей) используют этот канал для связи. Возможность общения с ними будет потеряна. Все равно удалить?",
        channelNotExists: "Канал c Ид {{channelId}} не существует",
        sendPulse: "SendPulse",
        sms: "Sms",
        importOperators: "Переместить менеджеров",
        currentChannel: "в канал",
        selectSourceChannel: "Выберите канал-источник",
        keepOperatorsInSourceChannel: "Сохранить менеджеров в канале-источнике",
        operatorsImported: "Менеджеры успешно перемещены."
    },
    chat: {
        transfer: "Перевод",
        comment: "Комментарий",
        transferToOperator: "Перевод на оператора",
        transferToBot: "Перевод на бота",
        transferToGroup: "Перевод на группу",
        invite: "Пригласить",
        editMessage: "Редактировать сообщение",
        doLeaveChat: "Вы хотите выйти из чата?",
        doExportChat: "Вы хотите экспортировать чат?",
        exportSuccess: "Чат успешно экспортирован",
        exportError: "Экспорт во внешнию CRM не настроен",
        externalCrmOptionsAreNotConfidured: "Настройки внешней crm не заданы",
        export: "Экспортировать",
        pause: "Пауза",
        unpause: "Снять паузу",
        setPauseHeader: "Выберите категорию паузы",
        removePauseHeader: "Снять паузу",
        removePause: "Снять паузу",
        resendMessage: "Переотправить сообщение",
        setPause: "Поставить на паузу",
        pauseWithoutNotifacation: "Пауза без уведомления клиента",
        pauseWithNotifacation: "Пауза с уведомлением клиента",
        pauseBotChatError: "Невозможно поставить чат с ботом на паузу",
        leave: "Покинуть",
        sendingFiles: "Отправка {{sendingFilesCount}} файла(ов)...",
        join: "Присоединиться",
        close: "Закрыть",
        closeChat: "Закрыть чат",
        save: "Сохранить",
        fillInfo: "Заполните информацию",
        category: 'Категория',
        subject: 'Тематика',
        categoryAndSubjectSavedError: 'Для закрытия чата заполните все поля',
        categoryAndSubjectSavedSuccessfully: 'Категория и тематика успешно сохранены',
        messageDeleted: "Message deleted",
        messageFileNoEdit: "Сообщение с файлом/изображением нельзя редактировать.",
        messageFileNoDelete: "Сообщение с файлом/изображением нельзя удалить.",
        cannotSaveEmptyMessaage: "Невозможно сохранить пустое сообщение, используйте кнопку удаления",
        cannotEditMessageWrongChannelType: "Невозможно отредактировать сообщение. Неправильный тип канала.",
        sendFileMessageError: "Произошла ошибка во время отправки файла",
        continue: "Продолжить",
        tagSaveError: "Для сохранения тегов заполните оба поля",
        tagSaveSuccess: "Теги успешно сохранены",
        markAsSpam: "Пометить как спам",
        contactHasOpenedChatException: "С этим контактом есть открытый чат. ChatId - {0} Operator - {1}",
        enabledChannelNotFoundException: "Невозможно начать новый чат, так как нет включенного канала",
        searchByMessenger: "Загружать историю из средства связи",
        cannotCloseChatNoAccesRights: "Невозможно закрыть чат, так как нет прав доступа",
        createNewChatError: "Нет запущенного канала для создания чата по мессенджеру",
        initConversationError: "Произошла ошибка при отправке шаблонного сообщения.",
        businessInitiatedTemplateNotFound: "Невозможно начать новый чат, так как в канале нет шаблона стартового сообщения.",
        chatTypePrivate: 'Личные сообщения',
        chatTypeGroup: 'Группа',
        chatTypeComment: 'Комментарии',
        chatTypeMailing: 'Рассылка',
        summary: 'Резюме',
        summaryCompleted: 'Завершено',
        summaryFailed: 'Ошибка',
        summaryInProgress: 'Обрабатывается',
        nluSearchTooltip: 'Поиск в NLU...',
        deleted: 'удалено',
        cannotEditDeleteMessage: "Нельзя отредактировать сообщение. Это сообщение было удалено.",
        chatClosedWaitingClientResponse: "Чат с клиентом создан с использованием шаблона и закрыт в ожидании ответа клиента.", 
        selectTemplate: "Выберите шаблон для отправки",
        show: "Показать",
        hide: "Скрыть",
        edited: "изменено",
        closeDialogWithoutSaving: "У вас есть несохраненные изменения. Вы уверены, что хотите закрыть?",
        closeChatTitle: "Выберите способ закрытия чата",
        closeNormally: "Закрыть чат c уведомлением",
        closeSilently: "Закрыть чат без уведомлений",
        quote: "Цитировать",
        deletedMessage: "Удаленное сообщение",
    },
    chats: {
        my: "Мои",
        withMe: "Со мной",
        all: "Все",
        archive: "Архив",
        autoUpdateChat: "Авто-обновление",
        info: "Информация",
        statistics: "Статистика",
        closed: "Закрыт",
        pause: "ПАУЗА",
        active: "Активен",
        expired: "Просрочен",
        finished: "Завершен",
        missed: "Пропущен",
        chatNumber: "Номер чата",
        askYouWannaCloseChat: "Вы хотите закрыть чат?",
        askYouWannaJoinChat: "Вы хотите присоединиться к чату?",
        askYouWannaReopenChat: "Вы хотите переоткрыть чат?",
        operatorNotAssignedYetMessage: "Еще не назначено",
        openChatErrorMessage: "Что-то пошло не так при открытии чата.",
        continueChatErrorMessage: "Не могу начать чат. Убедитесь, что канал существует и запущен.",
        editMessageSuccessMessage: "Отредактировано успешно",
        deleteMessageSuccessMessage: "Удалено успешно",
        deleteMessageError: "Произошла ошибка при удалении",
        editMessageErrorMessage: "Произошла ошибка при редактировании.",
        chatAlreadyClosing: "Закрытие чата уже в обработке",
        chatClosedSuccessfully: "Чат успешно закрыт",
        chatClosedErrorMessage: "Произошла ошибка при закрытии чата",
        enterChatName: "Введите название чата...",
        messageFromMyself: "Вы",
        messageFromClient: "Клиент",
        messageFromOperator: "Оператор",
        messageFromSystem: "Система",
        messageFromBot: "Бот",
        attachmentMessage: "*вложение*",
    },
    contact: {
        sureDeleteAccount: "Вы действительно хотите удалить аккаунт?",
        createNewAccounts: "Создать новый аккаунт",
        noRecords: "Записей нет",
        phoneNumber: "Номер телефона",
        firstName: "Имя",
        lastName: "Фамилия",
        middleName: "Отчество",
        name: "Имя",
        chatName: "Название чата",
        comment: "Комментарий",
        chatsCount: "Количество чатов",
        externalId: "Внешний Id",
        locale: "Язык",
        noContacts: "Нет контактов",
        createContact: "Создать контакт",
        saveContactSuccessMessage: "Сохранено успешно",
        saveNewContactSuccessMessage: "Контакт создан успешно",
        saveContactErrorMessage: "Ошибка во время сохранения контакта",
        saveNewContactErrorMessage: "Не удается сохранить новый контакт",
        deleteContactSuccessMessage: "Удалено успешно",
        deleteNewContactSuccessMessage: "Удалено успешно",
        deleteContactErrorMessage: "Ошибка при удалении контакта",
        deleteMessenger: "Вы действительно хотите удалить мессенджер?",
        cantDeletePrimaryContactMessenger: "Нельзя удалить основной мессенджер контакта",
        createMessenger: "Создать средство связи",
        channelName: "Название канала",
        messengerNickname: "Никнейм",
        messengerToken: "Номер",
        contactFoundMessage: "Контакт найден",
        contactNotFoundMessage: "Контакт не найден",
        contactReceivingByIdNotFoundMessage: "Контакт c id равным {{contactId}} не найден",
        chooseFile: "Выберите файл",
        errorSavingAccountWithoutData: "Не удается сохранить учетную запись с пустыми полями",
        errorSavingAccountOnlyWithSpaces: "Не удается сохранить учетную запись, где поля состоят из пробелов",
        errorSavingAccountCharactersEqualOrMore50: "Не удается сохранить учетную запись, где количество символов в поле превышает 50 символов",
        errorSavingAccountIdWithSpaces: "Не удается сохранить учетную запись, где поле id содержит пробелы",
        newDialogueWithClient: "Вы хотите начать новый диалог с клиентом?",
        fillAtLeastOneAnthroponym: "Введите хотя бы один антропоним: имя, фамилию или отчество",
        unsupportedAvatarImageType: "Неподдерживаемый тип изображения",
        firstMessengerDevice: "Информация о первом устройстве",
    },
    license: {
        botUsage: "Боты",
        operatorUsage: "Операторы",
        nlpUsage: "Запросы в NLU",
        mailingUsage: "Рассылки",
        currentUsage: "Сейчас использовано",
        avalableUsage: "Всего доступно",
        leftUsage: "Осталось",
        licenseExpiresAt: "Лицензия истекает {{date}}",
        licenseDaysLeft: "Осталось {{days}} дней",
        confirmPasswordNotMatchMessage: "Пароли не совпадают!",
        unknownErrorMessage: "Произошла ошибка при активации доступа, обратитесь к администратору!",
        licenseErrorMessage: "Ошибка лицензии, обратитесь к администратору!",
        licenseExpiredErrorMessage: "Лицензия истекла, обратитесь к администратору!",
        licenseAlreadyActivatedMessage: "Данная лицензия уже активирована.",
        userAlreadyExistMessage: "Пользователь с таким логином уже существует.",
        loginFormatErrorMessage: "Логин может содержать только буквы латинского алфавита, знак \"_\" и цифры ",
        updateLicenseSuccessMessage: "Лицензия обновлена успешно!",
        updateLicenseErrorMessage: "Ошибка обновления лицензии!",
        licenseExpiresPart: 'У вас осталось {{days}} дней лицензии, обратитесь к администратору!',
        mailingExpires: 'Вы использовали {{mailingUsed}} рассылок. Всего для Вашей лицензии доступно {{totalMailings}} рассылок',
        nlpExpires: 'Вы использовали поиск NLU {{nlpUsed}} раз. Всего для Вашей лицензии доступно {{totalNlps}}',
        license: "Лицензия",
        licenseDetails: "Детали лицензии",
        title: "Активация доступа",
        loginLabel: "Логин администратора",
        loginPlaceholder: "Логин",
        passwordLabel: "Пароль администратора",
        passwordPlaceholder: "Пароль",
        confirmPasswordLabel: "Повторите пароль",
        confirmPasswordPlaceholder: "Повторите пароль",
        licenseTitle: "Лицензия",
        submitButton: "Активировать доступ",
        notEnoughSlotsError: "Не хватает свободных слотов. Обратитесь к администратору по вопросам лицензирования",
        enabledOperatorsMoreThanSpecifiedInLic: "Количество активированных операторов превышает количество операторов в лицензии. Вы можете включать и отключать операторов в разделе Операторы",
        enabledBotsMoreThanSpecifiedInLic: "Количество активированных ботов превышает количество ботов в лицензии. Вы можете включать и отключать ботов в разделе Операторы",
        customerIdChanged: "Идентификатор клиента лицензии не может быть изменен.",
    },
    mailing: {
        bot: "Бот",
        mailingResult: "Результат рассылки",
        additionalData: "Дополнительные параметры",
        message: "Сообщение",
        linkText: "Текст ссылки",
        linkUrl: "Ссылка",
        image: "Изображение",
        isEmergency: "Разрешить отправку в активный чат",
        disableLinkTracking: "Не отслеживать переходы по ссылкам",
        sendingType: "Тип отправки",
        sendToAllMessengers: "Отправить во все мессенджеры",
        sendToLastMessenger: "Отправить в последний мессенджер",
        sendCascade: "Каскадная рассылка",
        uploadImage: "Загрузить",
        createMailing: "Создать рассылку",
        pending: "В ожидании..",
        inProgress: "В процессе",
        finished: "Завершена",
        canceled: "Отменено",
        stopped: "Остановлена",
        canNotSaveEmptyMessageError: "Нельзя сохранить пустое сообщение.",        
        canNotSendCascadeMailingWithoutSelectedChannels: "Для отправки каскадной рассылки необходимо выбрать каналы.",
        canNotSaveEmptyNameError: "Нельзя сохранить c пустым названием.",
        canNotSaveWrongLinkUrlError: "Нельзя сохранить. Неверный адресс ссылки",
        canSaveLinkWithoutLinkTextError: "Нельзя сохранить. Текст ссылки не заполнен",
        canNotSaveWithoutBotError: "Невозможно сохранить. Бот не выбран",
        saveMailingSuccess: "Рассылка сохранена успешно.",
        saveMailingError: "Произошла ошибка при сохранении.",
        startMailingStartMessage: "Началась рассылка.",
        deleteMailingSuccessMessage: "Удалено успешно",
        deleteMailingErrorMessage: "Произошла ошибка при удалении рассылки.",
        sendMessageFailed: "Произошла ошибка при отправки сообщения. Подробности в логах приложения",
        noFilterChoosenMessage: "Фильтр контактов/чатов не выбран, рассылка будет происходить всем контактам",
        contactsWithTemplates: "Контакты с шаблонами",
        templateVariables: "Переменные шаблона",
        mailingReceivingByIdNotFoundMessage: "Рассылка с id равным {{mailingId}} не найдена",
        fileMayNotBeDelivered: "Из-за размера файл может быть доставлен не во все мессенджеры.",
        mailingResultsReceivingByIdNotFoundMessage: "Результат рассылки с id равным {{mailingId}} не найден",
        stopMailingMessage: "Рассылка была остановлена.",
        sureDeleteMailing: "Вы действительно хотите удалить рассылку?",
    },
    nlp: {
        foundViaML: "Этот ответ был найден при помощи ИИ.",
        question: "Вопрос",
        answer: 'Ответ',
        createNewTopic: "Создать новую библиотеку",
        createNewPair: "Создать новую пару",
        doWantDeleteTopic: "Вы действительно хотите удалить библиотеку?",
        doWantDeleteTopicPair: "Вы действительно хотите удалить пару?",
        doWantUndoTopicPairChanges: "Вы хотите отменить все изменения пар?",
        selectPair: "Выбрать пару",
        applySelected: "Применить выбранное",
        deleteSelected: "Удалить выбранное",
        transferQuestion: "Переместить вопрос",
        move: "Переместить",
        to: "в",
        askYourQuestion: "Задайте ваш вопрос",
        unsupportedMessageType: "Неподдерживаемый тип сообщений",
        answerNotFound: "Ответ не найден",
        actualSearchString: "Фактическая строка поиска:",
        sureRemoveButton: "Вы действительно хотите удалить кнопку ",
        buttonType: "Тип кнопки",
        text: "Текст",
        value: "Значение",
        noFoundTopicPair: "Пара тем не найдена.",
        buttonTextExists: "Кнопка с таким текстом уже существует.",
        newButton: "Новая кнопка",
        buttonEditing: "Редактирование кнопки",
        saveTopicSuccessMessage: "Сохранено успешно",
        saveTopicErrorMessage: "Ошибка при сохранении темы",
        deleteTopicSuccessMessage: "Удалено успешно",
        deleteTopicErrorMessage: "Ошибка при удалении темы",
        exportPairsErrorMessage: "Ошибка при экспорте пар",
        importPairsErrorMessage: "Ошибка при импорте пар",
        importPairsSuccessMessage: "Успешный импорт пар",
        publishQuestionsSuccessMessage: "Опубликовано успешно",
        publishQuestionsMLSuccessMessage: "Опубликовано успешно (Режим машинного обучения)",
        publishQuestionsErrorMessage: "Ошибка при публикации",
        publishQuestionsMLErrorMessage: "Ошибка при публикации (Режим машинного обучения)",
        saveTopicPairSuccessMessage: "Сохранено успешно",
        saveTopicPairErrorMessage: "Ошибка при сохранении",
        synonyms: "Синонимы",
        synonyms_placeholder: "привет : здравствуйте|салют|хай|здорова\nклассно : отлично|гуд|круто\nчистый : свежий|опрятный|мытый",
        synonyms_fill: 'Заполните синонимы. Каждое слово с новой строки, затем двоеточие и его синонимы разделенные символом "|"',
        synonyms_needColon: "Отсутствует двоеточие между словом и синонимами в строке \n",
        synonyms_fewColons: "Более одного разделителя (:) в строке ",
        synonyms_wrongCharacter: "Недопустимый символ в строке \n",
        synonyms_needWord: "Отсутствует слово в строке \n",
        synonyms_needSynonyms: "Отсутствуют синонимы в строке \n",
        synonyms_emptySynonym: "Пустой синоним в строке \n",
        synonym_stopWord: "Ошибка. \"{{sw}}\" является стоп словом",
        deleteTopicPairSuccessMessage: "Успешно удалено",
        deleteTopicPairErrorMessage: "Ошибка при удалении",
        changeTopicPairStatusSuccessMessage: "Отредактировано успешно",
        changeTopicPairStatusErrorMessage: "Ошибка изменения статуса пар(ы) тем",
        transferQuestionToTopicPairSuccessMessage: "Перенесено успешно",
        transferQuestionToTopicPairErrorMessage: "Ошибка при переносе вопроса в пару тем",
        theme: "Тема",
        triggerName: "Название триггера",
        trigger: "Триггер",
        subject: "Тематика",
        source: "Источник",
        topicPairContentType_text: "Текст",
        topicPairContentType_markup: "Разметка",
        topicPairContentType_video: "Видео",
        topicPairContentType_audio: "Аудио",
        topicPairContentType_navigation: "Перенаправление",
        topicPairContentType_textToSpeech: "Автовоспроизведение",
        topicPairContentType_iframe: "Фрейм",
        nlpButtonType_trigger: "Триггер",
        nlpButtonType_text: "Текст",
        nlpButtonType_link: "Ссылка",
        nlpButtonType_customEvent: "Пользовательское Событие",
        nlpButtonType_back: "Назад",
        nlpButtonType_requestContact: "Запросить Контакт",
        nlpButtonType_requestGeolocation: "Запросить Геолокацию",
        nlpButtonEdit: "изменить",
        nlpButtonDelete: "удалить",
        errorSendNLPSearchWhenOperatorOffline: "Перейдите в онлайн или паузу, чтобы отправить сообщение",
        messageDontHaveAccessToTopic: "Извините, у вас нет доступа к этой теме",
        questionWithOnlyStopWordsError: "Вопрос <{{question}}> состоит из стоп слов",
        changeVersionConfirm: "Неопубликованные изменения будут потеряны, продолжить?",
        designerViewButton: "Дизайнер",
        listViewButton: "Список",
        designerAlignNodesButton: "Выровнять",
        designerTakeScreenshotButton: "Экспорт в файл",
        aiSearchWithNullConfidenceError: "Произошла ошибка при поиске с помощью вектора. Забыли опубликовать топик?",
        noOptionsText: "Подходящих вариантов не найдено",
        exceededLimitButton: "Превышен предел в 20 символов, кнопка может быть не доставлена в некоторые мессенджеры.",
        autocompleteOpenText: "Открыть",
        autocompleteCloseText: "Закрыть",
        autocompleteClearText: "Очистить",
        emptyNlpTooltipMessage: "Название библиотеки не может быть пустым",
        topicReceivingByIdNotFoundMessage: "Библиотека c id равным {{topicId}} не найдена",
        noAvailablePairsForTransfer: "Нет доступных пар для переноса"
    },
    operators: {
        name: "Имя",
        displayName: "Отображаемое имя",
        createOperator: "Создать оператора",
        sureRemoveOperator: "Вы действительно хотите удалить оператора?",
        emptyNameTooltipMessage: "Имя не может быть пустым",
        emptyLoginTooltipMessage: "Логин не может быть пустым",
        emptyPasswordTooltipMessage: "Пароль не может быть пустым",
        minLengthPasswordMessage: "Пароль должен быть длиннее, чем ",
        maxLengthPasswordMessage: "Пароль должен быть короче, чем ",
        minLengthLoginMessage: "Логин должен быть длиннее, чем ",
        maxLengthLoginMessage: "Логин должен быть короче, чем ",
        changeAvatarNullIdErrorMessage: "Невозможно изменить аватар не созданного оператора",
        saveOperatorSettingsNullIdMessage: "Невозможно сохранить настройки не созданного оператора",
        spaceInLoginErrorMessage: "Логин не может содержать пробелы",
        operatorCreatingErrorMessage: "Невозможно создать несколько операторов одновременно!",
        uploadScript: "Загрузить",
        saveOperatorNoChangesMessage: "Оператор не изменился",
        saveOperatorSuccessMessage: "Сохранено успешно",
        duplicatedOperatorNameErrorMessage: "Оператор с таким именем уже существует",
        duplicatedOperatorLoginErrorMessage: "Оператор с таким логином уже существует",
        incorrectFileFormatErrorMessage: "Неверный формат файла. Пожалуйста, загрузите .zip архив",
        deleteOperatorSuccessMessage: "Удалено успешно",
        cannotDeleteYourself: "Нельзя удалить оператора, под которым Вы залогинены",
        deleteOperatorErrorMessage: "Удаление оператора прошло с ошибкой",
        incorrectLoginMessage: "Логин содержит недопустимые символы",
        fileNotChoosen: "Файл не выбран",
        removeOperator: "Удалить Оператора",
        logoutOperatorByOperator: "Администратор {0} отключил Вас из системы",
        logoutOperator: "Администратор отключил Вас из системы",
        setAvatarError: "Произошла ошибка во время установки аватара",
        setAvatarSuccess: "Аватар успешно обновлен",
        downloadBotScriptError: "Произошла ошибка при выгрузке скрипта бота",
        operatorTypeOperator: "Оператор",
        operatorTypeBot: "Бот",
        operatorTypeSupervisor: "Супервизор",
        operatorTypeHuman: "Человек",
        operatorTypeQueue: "Очередь"
    },
    settings: {
        createSettings: "Создать настройку",
        settingIdCannotBeEmpty: "Невозможно сохранить настройку с пустым идентификатором.",
        confirmDeleteSetting: "Удалить настройку",
        settingIdAlreadyExists: "Настройка с идентификатором {id} уже существует.",
        settingId: "Название",
        emptySettingTooltipMessage: "Название не может быть пустым",
        key: "Ключ",
        value: "Значение",
        system: "Система",
        integration: "Интеграция",
        settingSaved: "Настройка успешно сохранена",
        settingDeleted: "Настройка удалена"
    },
    chatsPanel: {
        youAreLoggedInAs: "Вы вошли как ",
        toChangeTheUserPress: "Чтобы сменить пользователя нажмите ",
        haveBeenAssignedChannels: "Вам были назначены каналы: ",
        errorReopenChatDueOfflineStatus: "Перейдите в онлайн или паузу, чтобы продолжить чат",
        cannotOpenChatInWidgetChannel: "Не удается открыть чат в канале виджета.",
        sendMessageError: "Произошла ошибка во время отправки сообщения",
        sendFileMessageError: "Произошла ошибка во время отправки файла",
    },
    permission: {
        editPermissionsFor: "Изменить разрешения для ",
        tabRole: "Роли",
        tabUsers: "Пользователи",
        selectUser: "Выберите пользователя",
        Audit_Manage: "Управление аудитом",
        Contacts_Manage: "Управление контактами",
        Chats_ManageOwnChats: "Управление своими чатами",
        Chats_TransferChats: "Перевод чатов",
        Mailing_Manage: "Управление рассылками",
        Chats_ManageOthersChats: "Управление чужими чатами",
        NLP_Search: "Поиск в базе NLU",
        NLP_Manage: "Управление базой NLU",
        Operators_Manage: "Управление списком операторов и назначение каналов операторам",
        Channels_Manage: "Управление каналами",
        Integrations_Manage: "Управление настройками интеграций",
        CanManageAnalytics: "Работа с аналитикой",
        License_Manage: "Управление лицензией",
        savePermissionsSuccessMessage: "Разрешения сохранены успешно",
        Chats_SendFiles: "Отправка файлов",
        Permission_Manage: "Управление разрешениями",
        Chats_CloseSilently: "Закрытие чатов без уведомлений",
    },
    error: {
        nlpTopicAlreadyExistsError: "Библиотека с именем {{topicName}} уже существует.",
        disableWithOpenChats: "Не удалось обновить канал с идентификатором {{channelId}}: невозможно отключить канал, если открыты чаты",
        changeTokenWhenOpenChats: "Не удалось обновить канал с идентификатором {{channelId}}: невозможно изменить тип или токен, если на канале есть чаты.",
        connectionError: "Ошибка соединения. Попробуйте позже.",
        invalidDateMessage: "Неверный формат даты",
        leftDateLessMessage: "Дата слева меньше даты справа",
        error: "Ошибка!",
        channelNotInitialized: "Канал не инициализирован",
        nlpTopicNotFoundError: "Топик {{topicName}} не найден",
        invalidTokenErrorMessage: "Пожалуйста, авторизуйтесь, чтобы продолжить",
        loginFailed: "Ошибка авторизации. Проверьте логин и пароль",
        botBlockedByUser: "Пользователь заблокировал канал!",
        moreThanOneFile: "Вы можете перетащить только 1 файл",
        incorrectFileType: "Вы можете перетаскивать только файлы",
        FailedLicenseValidation: "Ошибка лицензии, обратитесь к администратору!",
        LicenseExpired: "Лицензия истекла, обратитесь к администратору!",
        LicenseAlreadyActivated: "Данная лицензия уже активирована.",
        UserAlreadyExist: "Пользователь с таким логином уже существует.",
        sendFileNotSupported: "Этот канал не поддерживает отправку файлов",
        typeOfSendedFileNotSupported: "Этот канал не поддерживает отправку данного типа файлов",
        saveImageBase64: "Невозможно сохранить изображение из изображения Base64",
        cannotSendMessageNotChatParticipant: "Невозможно отправить сообщение, поскольку оператор не является участником чата",
        sendMessageFailed: "Отправить сообщение не удалось. ChatId: {{chatId, number}} OperatorId: {{operatorId, number}}",
        duplicatedData: "Дублирование данных для {{constraintName}}",
        messengerNotFound: "Не получается найти доступные мессенджеры",
        chatNotFound: "Чат {{chatId}} не найден",
        fileMaxSize: "Максимальный размер файла не должен превышать {{maxSize}}MB",
        fileSizeExceeded: "Не удалось отправить файл. Его размер ({{currentSizeMb}} МБ) превышает максимально допустимый лимит в {{maxSizeMb}} МБ",
        fileDownloadError: "Ошибка загрузки файла",
        grafanaCreateScope: "Не удалось создать контекст для графаны",
        grafanaLogin: "Не удалось получить cookie для графиков",
        scriptFileNotFound: "Файл скрипта бота не найден",
        invalidOperatorModel: "Данные оператора недействительны для сохранения",
        fileTooLargeErrorMessage: "Размер файла слишком большой",
        chatAlreadyClose: "Чат {{chatId, number}} уже закрыт.",
        parentCommentDeleted: "Родительский комментарий был удален автором. Ответ не может быть отправлен.",
        messageSentOutsideOfAllowedWindow: "Сообщение не может быть отправлено в этот чат более чем через 24 часа после сообщения пользователя.",
        messageSentOutsideOf48HourAllowedWindow: "Сообщение не может быть отправлено в этот чат более чем через 48 часов после сообщения пользователя.",
        messageLengthExceeded: "Превышено допустимое количество символов. Максимальная длина сообщения: {{symbolsCount}} символов.",
        instagramUserDisabledMentions: "Упоминаемый пользователь отключил возможность его упоминать в настройках. Удалите упоминание и попробуйте ещё раз.",
        messageModificationOutsideOfAllowedWindow: "Сообщение нельзя модифицировать, прошло слишком много времени с момента отправки.",
        fetchFailedQr: "Не удалось получить QR-код",
        saveTelegramPrivateMessengerError: "Не удалось сохранить мессенджер для канала Телеграм (Личный)",
        channelClientNotInitializedException: "Канал не инициализирован, сначала включите канал. Channel id: {{channelId}}",
        chatNotCreated: "Чат не был открыт. Channel id: {{channelId}}, user id: {{userId}}",
        dailyLimitExceeded: "Превышен дневной лимит для пользоватя Telegram. Limit: {{limit}}.",
        commentUnavailable: "Не удалось отправить сообщение, так как комментарий недоступен. ChatId: {{chatId}}, MessageId: {{messageId}}",
        microphoneOrCameraPermissonNotGranted: "Чтобы эта функция работала, необходимо предоставить доступ к микрофону или камере",
        recordingVideoTooLarge: "Видеозапись слишком большая",
    },
    notification: {
        locationText: "Геолокация",
        documentText: "Документ",
        photoText: "Фото",
        newMessageInChat: "Новое сообщение в чате ",
        newChatRecieved: "Получен новый чат!",
        chatId: "ИД чата-",
        connectionError: "Ошибка соединения!",
        connectionErrorText: "Не удалось восстановить соединение, вы будете переведены в статус Offline",
        connectionAbortText: "Соединение было прервано. Обновите страницу для восстановления."
    },
    audit: {
        operatorConnectedBySignalR: "Оператор подключился по SignalR",
        operatorDisconnectedBySignalR: "Оператор отключился от SignalR",
        operatorWentOnline: "Оператор вышел в онлайн",
        operatorWentPause: "Оператор ушел на паузу",
        operatorWentOffline: "Оператор ушел в оффлайн",
        createSetting: "Оператор создал настройку",
        updateSetting: "Оператор обновил настройку",
        removeSetting: "Оператор удалил настройку",
        createChannel: "Оператор создал канал",
        updateChannel: "Оператор обновил канал",
        removeChannel: "Оператор удалил канал",
        createOperator: "Оператор создал оператора",
        updateOperator: "Оператор обновил оператора",
        removeOperator: "Оператор удалил оператора",
        operatorWentPause1: "Оператор ушел на паузу1",
        operatorWentPause2: "Оператор ушел на паузу2",
        operatorWentPause3: "Оператор ушел на паузу3",
        operatorWentPause4: "Оператор ушел на паузу4",
        operatorWentPause5: "Оператор ушел на паузу5",
        operatorWentPause6: "Оператор ушел на паузу6",
        operatorWentPause7: "Оператор ушел на паузу7",
        operatorWentPause8: "Оператор ушел на паузу8",
        operatorWentPause9: "Оператор ушел на паузу9",
        operatorWentPause10: "Оператор ушел на паузу10",
    },
    qr: {
        telegram: {
            scanCode: "Отсканируйте QR-код. Если срок действия QR-кода истек, подождите или нажмите обновить.",
            authorized: "Вы вошли в систему!",
            initializing: "Инициализация...",
            emptySettings: "Отсутствуют необходимые настройки: ApiId и ApiHash",
            startChannel: "Канал не запущен.",
            requiresPassword: "Требуется облачный пароль. Обновите страницу и проверьте настройки.",
            requiresManualInput: "Требуется ручной ввод. Обновите страницу и проверьте настройки.",
            loading: "Загрузка...",
            refresh: "Обновить",
            enterByQr: "Вход по Qr-коду",
        }
    }
};

export default translate;
